/* RESPONSIBLE TEAM: team-inbox-experience */
export default function toBackendPermissionKey(frontEndPermissionKey) {
  return frontEndPermissionKey.replace('can_', '');
}
